// extracted by mini-css-extract-plugin
export default {"button":"Shared_button__NTgRe"};